import { CALL_API } from '../../middleware/api';

/**
 * 时间轴添加
 */
export const TIMELINE_ADD_REQUEST = 'TIMELINE_ADD_REQUEST';
export const TIMELINE_ADD_SUCCESS = 'TIMELINE_ADD_REQUEST';
export const TIMELINE_ADD_FAILURE = 'TIMELINE_ADD_REQUEST';

/**
 * 时间轴更新
 */
export const TIMELINE_UPDATE_REQUEST = 'TIMELINE_UPDATE_REQUEST';
export const TIMELINE_UPDATE_SUCCESS = 'TIMELINE_UPDATE_SUCCESS';
export const TIMELINE_UPDATE_FAILURE = 'TIMELINE_UPDATE_FAILURE';

/**
 * 时间轴删除
 */
export const TIMELINE_DELETE_REQUEST = 'TIMELINE_DELETE_REQUEST';
export const TIMELINE_DELETE_SUCCESS = 'TIMELINE_DELETE_SUCCESS';
export const TIMELINE_DELETE_FAILURE = 'TIMELINE_DELETE_FAILURE';

/**
 * 时间轴列表
 */
export const TIMELINE_LIST_REQUEST = 'TIMELINE_LIST_REQUEST';
export const TIMELINE_LIST_SUCCESS = 'TIMELINE_LIST_SUCCESS';
export const TIMELINE_LIST_FAILURE = 'TIMELINE_LIST_FAILURE';

/**
 * 时间轴列表
 */
export const TIMELINE_ALL_REQUEST = 'TIMELINE_ALL_REQUEST';
export const TIMELINE_ALL_SUCCESS = 'TIMELINE_ALL_SUCCESS';
export const TIMELINE_ALL_FAILURE = 'TIMELINE_ALL_FAILURE';

// export function addTimeline(params) {
//   return {
//     [CALL_API]: {
//       types: [TIMELINE_ADD_REQUEST, TIMELINE_ADD_SUCCESS, TIMELINE_ADD_FAILURE],
//       endpoint: 'okr/objective/add',
//       methods: 'POST',
//       params
//     }
//   }
// }

export function updateTimeline(params) {
  return {
    [CALL_API]: {
      types: [TIMELINE_UPDATE_REQUEST, TIMELINE_UPDATE_SUCCESS, TIMELINE_UPDATE_FAILURE],
      endpoint: 'okr/time/update',
      methods: 'POST',
      params
    }
  }
}

export function deleteTimeline(params) {
  return {
    [CALL_API]: {
      types: [TIMELINE_DELETE_REQUEST, TIMELINE_DELETE_SUCCESS, TIMELINE_DELETE_FAILURE],
      endpoint: 'okr/time/delete',
      methods: 'POST',
      params
    }
  }
}

export function getTimelineList(params) {
  return {
    [CALL_API]: {
      types: [TIMELINE_LIST_REQUEST, TIMELINE_LIST_SUCCESS, TIMELINE_LIST_FAILURE],
      endpoint: 'okr/time/list?' + queryString.stringify(params),
      methods: 'GET',
      params
    }
  }
}

export function getTimelineAll() {
  return {
    [CALL_API]: {
      types: [TIMELINE_ALL_REQUEST, TIMELINE_ALL_SUCCESS, TIMELINE_ALL_FAILURE],
      endpoint: 'okr/time/all',
      methods: 'GET'
    }
  }
}


// WEBPACK FOOTER //
// ./src/action/okr_manage/timeline.js